import React, { useState } from "react";
import styles from "./WebOnboardingCard.module.scss";
import { handleOpenVideoPage } from "@/app/libs/const/handleOpenVideoPage";
import { RightClickModal } from "../RightClickModal/RightClickModal";
import { VideoLinkProvider } from "@/app/providers/video/VideoLinkProvider";
import { useMe, useCurrentOrganization } from "@/Hooks";

interface WebOnboardingCardProps {
  id: number;
  url: string;
  name: string;
  icon: string;
  shortname: string;
  selectActive: boolean;
  isSelected: boolean;
  onSelect: (id: number, url: string, videoId: number) => void;
  appId: number;
  slug: string;
  timeFrom: number;
  onboardingVideoId: number;
  hoveredWebOnboardingId: number | null;
  setHoveredWebOnboardingId: React.Dispatch<
    React.SetStateAction<number | null>
  >;
  openModal: (
    image: string,
    name: string,
    ts: number,
    id: number,
    idVideo: number,
    type: string,
    imageStoreId: number,
    idStore?: number,
    appId?: number,
    slug?: string,
  ) => void;
}

export const WebOnboardingCard: React.FC<WebOnboardingCardProps> = ({
  id,
  url,
  name,
  icon,
  shortname,
  selectActive,
  isSelected,
  onSelect,
  appId,
  slug,
  timeFrom,
  onboardingVideoId,
  hoveredWebOnboardingId,
  setHoveredWebOnboardingId,
  openModal,
}) => {
  const { me } = useMe();
  const currentOrganization = useCurrentOrganization();
  const [rightClickModalVisible, setRightClickModalVisible] = useState(false);
  const [rightClickPosition, setRightClickPosition] = useState({ x: 0, y: 0 });

  const handlePhotoClick = () => {
    // Open in modal instead of directly opening video page
    openModal(
      url,
      name,
      timeFrom,
      id,
      onboardingVideoId,
      "WebOnboarding",
      id,
      undefined,
      appId,
      slug,
    );
  };

  const handleRightClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setRightClickPosition({ x: e.clientX, y: e.clientY });
    setRightClickModalVisible(true);
  };

  const closeRightClickModal = () => {
    setRightClickModalVisible(false);
  };

  return (
    <div
      className={`${styles.root} ${isSelected ? styles.selectedRoot : ""}`}
      onMouseEnter={() => setHoveredWebOnboardingId(id)}
      onMouseLeave={() => setHoveredWebOnboardingId(null)}
      onContextMenu={handleRightClick}
    >
      <VideoLinkProvider
        timestamp={timeFrom || 0}
        slugText={slug}
        from="Saved Group Web Onboarding Screens"
        videoType={2}
        appId={appId}
        videoId={onboardingVideoId}
        userName={me?.username || ""}
        organizationId={currentOrganization?.uuid || ""}
        className={styles.photoItemTitle}
      >
        <div
          className={styles.photoItemTitle}
          // onClick={() =>
          //   handleOpenVideoPage(
          //     timeFrom || 0,
          //     slug,
          //     "saved-library/onboarding",
          //     2,
          //     appId,
          //     undefined,
          //     onboardingVideoId,
          //   )
          // }
        >
          <img src={icon} alt={`${name} icon`} loading="lazy" />
          <div className={styles.photoItemContent}>
            <h3>{name}</h3>
            <p>{shortname}</p>
          </div>
        </div>
      </VideoLinkProvider>

      <div
        className={`${styles.photoContainer} ${isSelected ? styles.selectedPhotoContainer : ""}`}
      >
        <div className={styles.containerPhoto} onClick={handlePhotoClick}>
          {(isSelected || id === hoveredWebOnboardingId) && (
            <div className={styles.selectButtonContainer}>
              <div className={styles.selectButtonContainerInner}>
                <button
                  className={`${styles.selectButton} ${isSelected ? styles.selected : ""}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (onSelect) {
                      onSelect(id, url, onboardingVideoId);
                    }
                  }}
                >
                  {isSelected && (
                    <img src="/img/blackIcon/Check.svg" alt="selectImage" />
                  )}
                </button>
              </div>
            </div>
          )}

          {id === hoveredWebOnboardingId && (
            <div className={styles.bottomMenuContainer}>
              <div className={styles.bottomMenuContainerInner}>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleOpenVideoPage(
                      timeFrom || 0,
                      slug,
                      "saved-library/onboarding",
                      2,
                      appId,
                      undefined,
                      onboardingVideoId,
                    );
                  }}
                >
                  <img src="/img/see-video-icon.svg" alt="see-video" />
                  <p>See Video</p>
                </button>
              </div>
            </div>
          )}

          <img
            src={url}
            alt={`${name} onboarding`}
            className={`${styles.photo} ${isSelected ? styles.selectedPhoto : ""}`}
            loading="lazy"
          />
        </div>
      </div>

      {rightClickModalVisible && (
        <RightClickModal
          x={rightClickPosition.x}
          y={rightClickPosition.y}
          onClose={closeRightClickModal}
          imageUrl={url}
          imageId={id}
          timestamp={timeFrom}
          isStoreScreen={false}
          handleOpenInNewTab={() =>
            handleOpenVideoPage(
              timeFrom || 0,
              slug,
              "saved-library/onboarding",
              2,
              appId,
              undefined,
              onboardingVideoId,
            )
          }
          avsID={onboardingVideoId}
          refetchData={() => console.log("Refetch data")}
          imageType="webOnboarding"
          onlyCopy
        />
      )}
    </div>
  );
};
